import React from "react";

import {
    FiMonitor,
    FiShoppingBag,
} from "react-icons/fi";


const BusinessFeatureTags = ({
    storefrontEnabled = false,
    marketplaceEnabled = false,
}) => {

    if (
        !storefrontEnabled &&
        !marketplaceEnabled
    ) {

        return (

            <div className="platform-business-feature-list">

                <small>
                    None
                </small>

            </div>

        );

    }


    return (

        <div className="platform-business-feature-list">

            {storefrontEnabled ? (

                <span>

                    <FiMonitor />

                    Storefront

                </span>

            ) : null}


            {marketplaceEnabled ? (

                <span>

                    <FiShoppingBag />

                    Marketplace

                </span>

            ) : null}

        </div>

    );

};


export default BusinessFeatureTags;